import {
  EMAIL_REGEX,
  ID_CARD_REGEX,
  MOBILE_PHONE_REGEX,
  UNION_ACCOUNT_REGEX,
} from '@bluevision/tools';

/** 应用名称 */
export const APP_NAME = 'vision_line';

/** 线上域名 */
export const PROD_HOSTNAME = 'akms.bluemediagroup.cn';

/** 媒体类型 */
export enum AllPlatform {
  Facebook = 'Facebook',
  Google = 'Google',
  Tiktok = 'Tiktok',
  Tiktok_SEA = 'Tiktok_SEA',
}
/** Facebook是否在封禁池 */
export enum FacebookInDisabled {
  NO = 0,
  YES = 1,
}
/** Facebook账户状态 */
export enum FacebookAccountStatus {
  ACTIVE = 1,
  DISABLED = 2,
  UNSETTLED = 3,
  PENDING_RISK_REVIEW = 7,
  PENDING_SETTLEMENT = 8,
  IN_GRACE_PERIOD = 9,
  PENDING_CLOSURE = 100,
  CLOSED = 101,
  ANY_ACTIVE = 201,
  ANY_CLOSED = 202,
}

export const FacebookAccountStatusText = {
  [FacebookAccountStatus.ACTIVE]: 'ACTIVE',
  [FacebookAccountStatus.DISABLED]: 'DISABLED',
  [FacebookAccountStatus.UNSETTLED]: 'UNSETTLED',
  [FacebookAccountStatus.PENDING_RISK_REVIEW]: 'PENDING_RISK_REVIEW',
  [FacebookAccountStatus.PENDING_SETTLEMENT]: 'PENDING_SETTLEMENT',
  [FacebookAccountStatus.IN_GRACE_PERIOD]: 'IN_GRACE_PERIOD',
  [FacebookAccountStatus.PENDING_CLOSURE]: 'PENDING_CLOSURE',
  [FacebookAccountStatus.CLOSED]: 'CLOSED',
  [FacebookAccountStatus.ANY_ACTIVE]: 'ANY_ACTIVE',
  [FacebookAccountStatus.ANY_CLOSED]: 'ANY_CLOSED',
};

/** Google账户状态 */
export enum GoogleAccountStatus {
  UNSPECIFIED = 600,
  UNKNOWN = 601,
  ENABLED = 602,
  CANCELED = 603,
  SUSPENDED = 604,
  CLOSED = 605,
}

export const GoogleAccountStatusText = {
  [GoogleAccountStatus.UNSPECIFIED]: 'UNSPECIFIED',
  [GoogleAccountStatus.UNKNOWN]: 'UNKNOWN',
  [GoogleAccountStatus.ENABLED]: 'ENABLED',
  [GoogleAccountStatus.CANCELED]: 'CANCELED',
  [GoogleAccountStatus.SUSPENDED]: 'SUSPENDED',
  [GoogleAccountStatus.CLOSED]: 'CLOSED',
};

/** Tiktok账户状态 */
export enum TiktokAccountStatus {
  UNKNOWN = 50,
  NOT_PASSED = 51,
  PASSED = 52,
  UNDER_REVIEW = 53,
  PUNISHMENT = 54,
  DISABLED = 55,
  APPLY_FOR_REVIEW = 56,
  AWAIT_VALIDATION = 57,
  REVIEW_NOT_PASSED = 58,
  REVIEW_PASSED = 59,
  CRM_REVIEW_NOT_PASSED = 510,
  MODIFY_APPLY_FOR_REVIEW = 511,
  MODIFY_REVIEW_NOT_PASSED = 512,
  DEACTIVATE = 513,
  AWAIT_CRM_REVIEW = 514,
  AWAIT_PUBLIC_VALIDATION = 515,
  AWAIT_QUALIFICATION_VALIDATION = 516,
  CONTRACT_NOT_EFFECTIVE = 517,
  IN_BAN_POOL = 518, // 被封池标记中
}


export const TiktokAccountStatusText = {
  [TiktokAccountStatus.UNKNOWN]: 'UNKNOWN',
  [TiktokAccountStatus.NOT_PASSED]: 'NOT_PASSED',
  [TiktokAccountStatus.PASSED]: 'PASSED',
  [TiktokAccountStatus.UNDER_REVIEW]: 'UNDER_REVIEW',
  [TiktokAccountStatus.PUNISHMENT]: 'PUNISHMENT',
  [TiktokAccountStatus.DISABLED]: 'DISABLED',
  [TiktokAccountStatus.APPLY_FOR_REVIEW]: 'APPLY_FOR_REVIEW',
  [TiktokAccountStatus.AWAIT_VALIDATION]: 'AWAIT_VALIDATION',
  [TiktokAccountStatus.REVIEW_NOT_PASSED]: 'REVIEW_NOT_PASSED',
  [TiktokAccountStatus.REVIEW_PASSED]: 'REVIEW_PASSED',
  [TiktokAccountStatus.CRM_REVIEW_NOT_PASSED]: 'CRM_REVIEW_NOT_PASSED',
  [TiktokAccountStatus.MODIFY_APPLY_FOR_REVIEW]: 'MODIFY_APPLY_FOR_REVIEW',
  [TiktokAccountStatus.MODIFY_REVIEW_NOT_PASSED]: 'MODIFY_REVIEW_NOT_PASSED',
  [TiktokAccountStatus.DEACTIVATE]: 'DEACTIVATE',
  [TiktokAccountStatus.AWAIT_CRM_REVIEW]: 'AWAIT_CRM_REVIEW',
  [TiktokAccountStatus.AWAIT_PUBLIC_VALIDATION]: 'AWAIT_PUBLIC_VALIDATION',
  [TiktokAccountStatus.AWAIT_QUALIFICATION_VALIDATION]: 'AWAIT_QUALIFICATION_VALIDATION',
  [TiktokAccountStatus.CONTRACT_NOT_EFFECTIVE]: 'CONTRACT_NOT_EFFECTIVE',
  [TiktokAccountStatus.IN_BAN_POOL]: 'IN_BAN_POOL',
};


// 身份证正则
export const idCardPattern = ID_CARD_REGEX;
// 银联账户正则
export const unionAccountPattern = UNION_ACCOUNT_REGEX;
// 手机号正则
export const phonePattern = MOBILE_PHONE_REGEX;
// 邮箱正则
export const emailPattern = EMAIL_REGEX;

/** LocalStorage Key */
export enum LocalStorageKey {
  /** 用户反馈功能提示是否弹出 */
  FEEDBACK_POPOVER = 'FEEDBACK_POPOVER',
  /** 新功能通知是否已点击过我知道了 */
  NEW_FEATURE_NOTIFICATION_CLICKED = 'NEW_FEATURE_NOTIFICATION_CLICKED',
  /** 缓存的用户信息 */
  CACHED_USER_INFO = 'cached_user_info',
  /** 防盗刷监控配置提醒弹窗是否已检查过 */
  BRUSH_MONITORING_REMINDER_CHECKED = 'BRUSH_MONITORING_REMINDER_CHECKED',
  /** 防盗刷监控配置提醒弹窗是否已关闭 */
  BRUSH_MONITORING_REMINDER_CLOSED = 'BRUSH_MONITORING_REMINDER_CLOSED',
  /** SPARK ADS 绑号 workflow for CNOB 通知 */
  SPARK_ADS_BINDING_WORKFLOW_FOR_CNOB_NOTIFICATION = 'SPARK_ADS_BINDING_WORKFLOW_FOR_CNOB_NOTIFICATION',
}

/** StringBoolean 为了判断本地缓存中的值使用 */
export enum StringBoolean {
  TRUE = 'true',
  FALSE = 'false',
}

/** 业务单元 */
export const BUSINESS_UNIT = {
  BV: 1,
  TOMATO: 2,
} as const;
